
export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0UbdFZPgHYoKglrVK9an
qJ+5ehWmK7nSGsuicFEEqeVLs8qUf7PF4c/NKUeEGcXg0ovH+hTLVrtXNG2WuWiE
LEAybqXEILIGcGBSTuWD38R6lMPzvLB15BqaDWr/mYvK9OGcmyL83x3X2wSa8ufg
/zJTAJCZ7UXsiPqN6sKUB9v/7WMLqyEBDyqeRryQaGkjGG3UvJAtN97b7GvEVm/P
vTSAEUIFMVnzzKA7e9pP9XwvJ8g074IwqVCOhqjkQ0+7aKaOHcnOhPSGlnLmnP9T
1O8NDffR1LU/Mzf/GoJeT4uguo00Nm/jugBv7zObRWFtiXrH+Oqlz5cRBWfWb2bE
cQIDAQAB
-----END PUBLIC KEY-----`;



// WEBPACK FOOTER //
// ./resources/assets/js/keys/keys.js